import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import PlaceComponent from './place';
import PlaceUsaComponent from './place-usa';

export default createReactClass({

	propTypes: {
		places: PropTypes.array,
		region: PropTypes.string
	},

	renderItem(place, i) {
		return (this.props.region === 'usa') ? <PlaceUsaComponent data={place} key={place.title}/> : <PlaceComponent data={place} key={place.title}/>;
	},

	render() {
		return (
			<ul>
				{this.props.places.map(this.renderItem)}
			</ul>
		);
	}
});
